import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Pagination from '../../components/pagination/Pagination'
import axios from '../../../axios/axios';
import NewsItem from './NewsItem';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            maxValue: 0,
            currentValue: 0,
            minValue: 1,
            news: [],
            newsActiveId: null,
            loading: false
        }
    }

    componentDidMount() {
        this.getNews(0, this.state.size);
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getNews(this.state.currentValue, this.state.size);
        }
    }

    getNews(page, size) {
        this.setState({...this.state, loading: true }, () => {
            axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
            axios.get(`api/welsend/public/news/langDetailAndFileMetadata?page=${page}&size=${size}`)
            .then(res => res.data)
            .then(news => {
                this.setState({...this.state, maxValue: news.totalPages, loading: false,
                                            [page]: news.newsDtos, news: news.newsDtos, currentValue: page})
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    directionPagination = (dir) => {
        switch(dir) {
            case 'left': {
                if (this.state.currentValue >= this.state.minValue) {
                    this.getNews(this.state.currentValue - 1, 10)
                }  
                break;
            }
            case 'right': {
                if (this.state.currentValue < this.state.maxValue) {
                    this.getNews(this.state.currentValue + 1, 10)
                }
                break;
            }
        }
    }

    handleShowFullText = (id) => {
        this.setState({...this.state, newsActiveId: id})
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        axios.post(`api/welsend/public/news/${id}/viewTextFull`)
        .catch((error =>  {
            console.log(error);
        }))
    }

    handleHidePreviewText = () => {
        this.setState({...this.state, newsActiveId: ''})
    }

    newsList() {
        if (this.state.news.length > 0) {
          const news =  this.state.news.map(item => {
            let isActive = false;
            if (item.newsId === this.state.newsActiveId) {
                isActive = true;
            }
            return <NewsItem news={item} 
                              key={item.newsId} 
                              active={isActive}
                              hidePreviewText={this.handleHidePreviewText}
                              showFullText={this.handleShowFullText}
                              defaultStaticContentNews={this.props.defaultStaticContentNews}
                              activeLangStaticContentNews={this.props.activeLangStaticContentNews}
                    />})
          return news;
        }  else return null;
    }

    render() {
        return (
            <div className="container news">
                <h1>
                    {translateStaticContent('newsHeading', 
                        this.props.defaultStaticContentNews, this.props.activeLangStaticContentNews)}
                </h1>
                {this.state.loading ? <Loader /> : 
                    <div>
                        <div className='page'>
                            {this.newsList()}
                        </div>
                        <Pagination max={this.state.maxValue} 
                                min={this.state.minValue} 
                                current={this.state.currentValue + 1}
                                dir={this.directionPagination}
                     /> 
                    </div>
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})
export default connect(mapStateToProps)(News);

News.propTypes = {
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentNews: PropTypes.object,
    activeLangStaticContentNews: PropTypes.object,
}